import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { StripeProvider } from 'react-stripe-elements';

import Home from "./screens/general/Home";
import Events from "./screens/general/Events";
import Contact from "./screens/general/Contact";
import PurchaseScreen from "./screens/general/PurchaseScreen"
import NoMatch from "./screens/general/NoMatch"
import NavigationBar from "./components/NavigationBar";
import { Layout } from './components/Layout'
import { Jumbotron } from './components/Jumbotron'
import SignUpPage from "./screens/registration/EmailScreen"
import SignInPage from "./screens/registration/SignIn"
import PasswordForgetPage from "./screens/registration/PasswordForget"
import AuthChoice from "./screens/registration/AuthChoice"
import { AuthUserContext } from './components/Session';
import { withAuthentication } from './components/Session';
import { withFirebase } from './components/Firebase';
import SpecificEvent from "./screens/general/SpecificEvent";
import CreateEvent from "./screens/general/CreateEvent";
import organizerRegistration from "./screens/organizerOnboarding/organizerRegistration";
import Advertise from "./screens/general/Advertise";
import Advertise2 from "./screens/general/Advertise2"

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: null,
    };
  }



  render() {
    return (
      <React.Fragment>

        <StripeProvider apiKey="pk_test_KRXEAIgnZ0wqWL0hVNYnnVyb00OMtrHiCG">
          <Layout>
            <Router>
              <NavigationBar />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/contact" component={Contact} />
                <Route path="/advertise2" component={Advertise2} />
                {/* <Route path="/events" component={Events} />
                <Route path="/purchase" component={PurchaseScreen} />
                <Route path="/email" component={SignUpPage} />
                <Route path="/signin" component={SignInPage} />
                <Route path="/forgot" component={PasswordForgetPage} />
                <Route path="/auth" component={AuthChoice} />
                <Route path="/specific-event" component={SpecificEvent} /> */}
                <Route path="/advertise" component={Advertise} />
                {/* <Route path="/org-onboard" component={organizerRegistration} />
                <Route path="/create-event" component={CreateEvent} /> */}
                <Route component={NoMatch} />
              </Switch>
            </Router>
          </Layout>
        </StripeProvider>

      </React.Fragment>
    );
  }
}

export default withAuthentication(App);


{/* <script src="/__/firebase/7.6.1/firebase-app.js"></script>
        <script src="/__/firebase/7.6.1/firebase-analytics.js"></script>
        <script src="/__/firebase/init.js"></script> */}